module.exports = __webpack_public_path__ + "static/media/earth-video-smaller.62f2bac9.mp4";